import { CircleCheck, CircleHelp, CircleX } from 'lucide-react';

import { Relevance } from '../../../types';

const getRelevanceInfo = (relevance: Relevance) => {
  switch (relevance) {
    case Relevance.YES:
      return { text: 'Relevant', color: 'text-green-600', icon: <CircleCheck size={14} /> };
    case Relevance.MAYBE:
      return { text: 'Maybe Relevant', color: 'text-orange-400', icon: <CircleHelp size={14} /> };
    case Relevance.NO:
      return { text: 'Not Relevant', color: 'text-red-600', icon: <CircleX size={14} /> };
    default:
      return null;
  }
};

export const RelevanceIndicator = ({ relevance }: { relevance: Relevance }) => {
  const relevanceInfo = getRelevanceInfo(relevance);

  if (!relevanceInfo) return null;

  const { text, color, icon } = relevanceInfo;

  return (
    <p className={`flex w-max items-center justify-end gap-1.25 text-xs ${color}`}>
      {icon}
      <span className="pt-0.25 text-gray-600">{text}</span>
    </p>
  );
};
